module.exports = __webpack_public_path__ + "static/media/Manuel_2_Géné_X_3.0.cd3ac6c8.pdf";